<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <core-upsert
        :config="config"
        :item="protocol_detail"
        :title="'Protocol Details for ' + protocol.name "
        @saved="saved">


        <template slot='headerActions'>
          <v-btn
            color="secondary"
            @click="$router.push('/protocol/' + protocol.id)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

           <v-btn
            color="secondary"
            @click="generateDiagram">
            <v-icon>mdi-family-tree</v-icon>
          </v-btn>

        </template>

       
      </core-upsert>

      
    </v-flex>

  </v-container>
</template>

<script>
import { getDetail } from '@/api/base_entity'
import { generateDiagram } from '@/api/protocol'
import config from './config_index.js'


export default {
  inheritAttrs: false,
  data () {
    return {
      config,
      protocol_detail: {},
      protocol: {},
    }
  },
  async created () {
    const pd = await getDetail('protocol_detail', this.$route.params.id)
    this.protocol_detail = !Array.isArray(pd) ? pd : {}
    this.protocol = await getDetail('protocol', this.$route.params.id)
    this.protocol_detail.protocol_id = this.$route.params.id
    this.protocol_detail.name = this.protocol.name
  },
  mounted () {
  },
  methods: {
    saved () {
    },
    generateDiagram() {
      generateDiagram(this.$route.params.id)
      // .then( ret => {
      //   console.log(ret)
      // })
    }
    
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
